/**
 * Removes the port from a Host header or hostname when present.
 * e.g.: "localhost:3000" -> "localhost", "[::1]:3000" -> "[::1]"
 */
const stripPortFromHost = (host: string): string => host.replace(/:\d+$/, "");

/**
 * Extracts the base domain from a hostname (removes subdomains).
 * e.g.: "multi01.qrcreator.com" -> "qrcreator.com"
 * e.g.: "qrcreator.com" -> "qrcreator.com"
 * e.g.: "local-app.qrcreator.com" -> "qrcreator.com"
 */
export const extractBaseDomain = (hostname: string): string => {
  const host = stripPortFromHost(hostname);

  if (!host || host === "localhost") {
    return host || "localhost";
  }

  const domainParts = host.split(".");
  if (domainParts.length < 2) {
    return host;
  }

  const lastPart = domainParts[domainParts.length - 1];
  const tldPattern = /^[a-z]{2,}$/i;

  if (tldPattern.test(lastPart)) {
    return domainParts[domainParts.length - 2] + "." + lastPart;
  }

  return host;
};
